import { useCallback } from 'react';
import useWfApi from './axios/useWfApi';
import { WfUser } from '../models/WfUser';

export interface WfLocationUpdateRequestBody {
  latitude: number;
  longitude: number;
}

export interface WfGetUsersRequestBody {
  centerLat: number;
  centerLon: number;
  searchRange: number;
}

export interface UsersSearchParameters {
  name?: string;
  ldapId?: string;
  telephoneNumber?: string;
}

export const useWfUserRepo = () => {
  const { get, patch } = useWfApi();

  const getUserRequest = useCallback(async () => {
    try {
      return (await get<WfUser>(`/api/wf/users/me`)) ?? null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }, [get]);

  const getUsersByLocationRequest = useCallback(
    async (parameters: WfGetUsersRequestBody) => {
      try {
        return (
          (await get<WfUser[]>('/api/wf/users', {
            params: parameters,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })) ?? []
        );
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    [get]
  );

  const patchUserLocationRequest = useCallback(
    async (body: WfLocationUpdateRequestBody) => {
      try {
        return await patch<WfUser>(`/api/wf/users/me`, body);
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [patch]
  );

  const getUsersByNameLdapPhoneNoRequest = useCallback(
    async (parameters: UsersSearchParameters) => {
      try {
        return (
          (await get<WfUser[]>('/api/wf/users/search', {
            params: parameters,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })) ?? []
        );
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    [get]
  );

  return {
    getUserRequest,
    getUsersByLocationRequest,
    patchUserLocationRequest,
    getUsersByNameLdapPhoneNoRequest,
  };
};

export default useWfUserRepo;
